import React from 'react'
import '../styles/layout/Services.css'
import { Container } from 'react-bootstrap';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

/**
 * The medallions used to hold 100x100 PNGs blown up into a ~124px disc, which
 * was soft at 1x and mush on a retina screen. Same six benefits, now drawn as
 * vectors so they stay sharp at any size and density.
 */
const BENEFITS = [
    { Icon: TuneOutlinedIcon, title: 'Flexible' },
    { Icon: TrendingUpOutlinedIcon, title: 'Scalable' },
    { Icon: SavingsOutlinedIcon, title: 'Economical' },
    { Icon: MemoryOutlinedIcon, title: 'State of Art Technology' },
    { Icon: InsightsOutlinedIcon, title: 'Analytics' },
    { Icon: CampaignOutlinedIcon, title: 'Marketing Solutions' },
]

const ServiceBenifits = () => {
  return (
    <section className='benifits section section--defer'>
        <span className="aurora aurora--violet aurora--low" aria-hidden="true" />
        <Container>
            <div className="benifits__head reveal">
                <h2>Benefits</h2>
                <span className="rule rule--center" />
            </div>
            <ul className="benifits__grid">
                {BENEFITS.map(({ Icon, title }, i) => (
                    <li className="benefit reveal" key={title} data-delay={(i % 3) + 1}>
                        <span className="benefit__ring" aria-hidden="true">
                            <span className="benefit__disc">
                                <Icon />
                            </span>
                        </span>
                        <h3 className="benefit__label">{title}</h3>
                    </li>
                ))}
            </ul>
        </Container>
    </section>
  )
}

export default ServiceBenifits
